import { Injectable } from '@angular/core';

import { AdvertisingActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { map, takeUntil, withLatestFrom } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadFreemiumViewerCampaignGuard  {

  constructor(private store$: Store<fromRoot.State>) { }

  canActivate(): Observable<boolean> {
    return this.loadFreemiumViewerCampaign().pipe(map((campaignFreemiumLoaded: boolean) => {
      return campaignFreemiumLoaded;
    }));
  }

  loadFreemiumViewerCampaign(): Observable<boolean> {
    const campaignFreemiumLoaded$ = new ReplaySubject<boolean>();
    this.store$.dispatch(AdvertisingActions.LoadCampaign({ target: 'Viewer' }));
    this.store$.pipe(
      takeUntil(campaignFreemiumLoaded$),
      withLatestFrom(
        this.store$.select(fromRoot.getCampaignFreemiumLoaded),
      ),
    ).subscribe(([_, loaded]: any[]) => {
      if (loaded) {
        campaignFreemiumLoaded$.next(true);
      }
    });
    return campaignFreemiumLoaded$.asObservable();
  }
}

